<template>
  <SidebarListItem :isActive="isActive">
    <img
      slot="icon"
      :src="socialProfile.picture" alt="profile picture"
      :class="$style.image"
    >
    {{ socialProfile.firstName }} {{ socialProfile.lastName }}
    <BaseIcon
      slot="corner"
      v-if="socialProfile.isOwn"
      name="cog"
      @click.prevent="$router.push({ name: 'social-edit-profile', params: { profileNickname: socialProfile.nickname } })"
    />
    <template slot="info">
      {{ socialProfile.updatedAt | date('Pp') }}
    </template>
  </SidebarListItem>
</template>

<script>
import SidebarListItem from '@/components/SidebarListItem'

export default {
  name: 'social-list-item',
  components: {
    SidebarListItem
  },
  props: {
    socialProfile: Object
  },
  computed: {
    isActive () {
      return this.$route.name === 'social' && this.$route.params.profileNickname === this.socialProfile.nickname
    }
  }
}
</script>

<style module lang="scss">
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
